import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Typography,
  Link,
  List,
  ListItem,
  useMediaQuery,
} from "@mui/material";

/**
 * イベント詳細情報を表示するコンポーネント
 * @param props - イベント情報を含むオブジェクト
 * @returns イベント詳細情報のテーブルまたはリスト
 */
export const EventInfo = (props: any) => {
  // レスポンシブ対応のためのメディアクエリ
  const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <TableContainer component={Paper}>
      {/* "イベント詳細"バー */}
      <Typography
        sx={{
          color: "#fff",
          backgroundColor: "#3f51b5",
          padding: "10px",
          textAlign: "center",
          borderRadius: "5px",
        }}
      >
        イベント詳細
      </Typography>

      {/* イベント詳細情報テーブル */}
      {isMobile ? (
        // モバイルの場合、テーブルではなくリストで表示
        <List>
          {/* イベント名 */}
          <ListItem sx={{ display: "flex", flexDirection: "column", paddingBottom: 2 }}>
            <Typography sx={{ fontWeight: "bold", width: "25%", textAlign: "center" }}>イベント名</Typography>
            <Typography>{props?.eventInfo?.eventName}</Typography>
          </ListItem>

          {/* 日程 */}
          <ListItem sx={{ display: "flex", flexDirection: "column", paddingBottom: 2 }}>
            <Typography fontWeight="bold">日程</Typography>
            <Typography>{props?.eventInfo?.eventDate}</Typography>
          </ListItem>

          {/* バスケ時間 */}
          {props?.eventInfo?.b_eventTime ? (
            <>
              <ListItem sx={{ display: "flex", flexDirection: "column", paddingBottom: 2 }}>
                <Typography fontWeight="bold">バスケ</Typography>
                <Typography>
                  {props?.eventInfo?.b_eventTime[0]} ～ {props?.eventInfo?.b_eventTime[1]}
                </Typography>
              </ListItem>
            </>) : (<></>)}

          {/* 飲み会時間 */}
          {props?.eventInfo?.d_eventTime ? (
            <>
            <ListItem sx={{ display: "flex", flexDirection: "column", paddingBottom: 2 }}>
              <Typography fontWeight="bold">飲み会</Typography>
              <Typography>
                {props?.eventInfo?.d_eventTime[0]} ～ {props?.eventInfo?.d_eventTime[1]}
              </Typography>
            </ListItem>
            </>
          ) : (<></>)}

          {/* 参加費 */}
          <ListItem sx={{ display: "flex", flexDirection: "column", paddingBottom: 2 }}>
            <Typography fontWeight="bold">参加費</Typography>
            {props?.eventInfo?.d_entryFee > 0 && props?.eventInfo?.b_entryFee > 0 ? (
              <>
                {/* バスケ、飲み会両方 */}
                <Typography>
                  バスケ {props?.eventInfo?.b_entryFee}円 / 飲み会 {props?.eventInfo?.d_entryFee}円
                </Typography>
              </>
            ) : (
              <>
                {props?.eventInfo?.b_entryFee > 0 ? (
                  <>
                    {/* バスケのみ */}
                    <Typography>{props?.eventInfo?.b_entryFee}円</Typography>
                  </>
                ) : (
                  <>
                    {props?.eventInfo?.d_entryFee > 0 ? (
                      <>
                        {/* 飲み会のみ */}
                        <Typography>{props?.eventInfo?.d_entryFee}円</Typography>
                      </>
                    ) : (
                      <>
                        {/* どちらもない場合は何も表示しない */}
                      </>
                    )}
                  </>
                )}
              </>
            )}
          </ListItem>

          {/* 開催場所 */}
          {props?.eventInfo?.arenaName ? (
            <>
              <ListItem sx={{ display: "flex", flexDirection: "column", paddingBottom: 2 }}>
                <Typography fontWeight="bold">開催場所</Typography>
                <Typography>
                  {props?.eventInfo?.arenaUrl ? (
                    <Link href={props?.eventInfo?.arenaUrl} target="_blank" rel="noopener">
                      {props?.eventInfo?.arenaName}
                    </Link>
                  ) : props?.eventInfo?.arenaName}
                </Typography>
              </ListItem>
            </>
          ) : (<></>)}

          {/* 飲み会場 */}
          {props?.eventInfo?.restaurant ? (
            <>
              <ListItem sx={{ display: "flex", flexDirection: "column", paddingBottom: 2 }}>
                <Typography fontWeight="bold">飲み会場</Typography>
                <Typography>
                  {props?.eventInfo?.restaurantUrl ? (
                    <Link href={props?.eventInfo?.restaurantUrl} target="_blank" rel="noopener">
                      {props?.eventInfo?.restaurant}
                    </Link>
                  ) : props?.eventInfo?.restaurant}
                </Typography>
              </ListItem>
            </>
          ) : (<></>)}

          {/* 集合 */}
          <ListItem sx={{ display: "flex", flexDirection: "column", paddingBottom: 2 }}>
            <Typography fontWeight="bold">集合</Typography>
            <Typography>{props?.eventInfo?.meeting[0]} {props?.eventInfo?.meeting[1]}</Typography>
          </ListItem>

          {/* 人数 */}
          <ListItem sx={{ display: "flex", flexDirection: "column", paddingBottom: 2 }}>
            <Typography fontWeight="bold">人数</Typography>
            <Typography>{props?.eventInfo?.participantsNum}人 / {props?.eventInfo?.capacityNum}人</Typography>
            <Typography>
              {/* 男性満員の場合、その旨を表示 */}
              {props?.eventInfo?.manParticipantsNum >= props?.eventInfo?.manCapacityNum ? (<><Typography>※男性満員です</Typography></>) : (<></>)}
              {/* 女性満員の場合、その旨を表示 */}
              {props?.eventInfo?.womanParticipantsNum >= props?.eventInfo?.womanCapacityNum ? (<><Typography>※女性満員です</Typography></>) : (<></>)}  
              {/* 満員の場合、キャンセル待ちを表示 */}
              {props?.eventInfo?.isSoldOut ? (
                <>
                  <Typography>現在のキャンセル待ち：{props?.eventInfo?.cancelWaitReserveNum}人</Typography>
                </>
              ) : (<></>)}
              {/* 満員の場合、キャンセル待ち位置を表示 */}
              {props?.eventInfo?.isSoldOut && props?.eventInfo?.cancelWaitPotision > 0 ? (
                <>
                  {/* 改修完了まで表示を消す */}
                  {/* <Typography fontWeight={"bold"} color={"error.main"}>あなたはキャンセル待ち{props?.eventInfo?.cancelWaitPotision}番手です</Typography> */}
                </>
              ) : (<></>)}
            </Typography>
          </ListItem>

          {/* 内容 */}
          <ListItem sx={{ display: "flex", flexDirection: "column", paddingBottom: 2 }}>
            <Typography fontWeight="bold">内容</Typography>
            <Typography>
              {props?.eventInfo?.eventContent?.split('\n').map((line: string, index: number) => (
                <span key={index}>{line}<br /></span>
                ))}
            </Typography>
          </ListItem>

          {/* 持ち物 */}
          <ListItem sx={{ display: "flex", flexDirection: "column", paddingBottom: 2 }}>
            <Typography fontWeight="bold">持ち物</Typography>
            <Typography>
              {props?.eventInfo?.belongings?.split('\n').map((line: string, index: number) => (
                <span key={index}>{line}<br /></span>
                ))}
            </Typography>
          </ListItem>

          {/* 設備 */}
          <ListItem sx={{ display: "flex", flexDirection: "column", paddingBottom: 2 }}>
            <Typography fontWeight="bold">設備</Typography>
            <Typography>
              {props?.eventInfo?.facility?.split('\n').map((line: string, index: number) => (
                <span key={index}>{line}<br /></span>
                ))}
            </Typography>
          </ListItem>

          {/* 注意事項 */}
          <ListItem sx={{ display: "flex", flexDirection: "column", paddingBottom: 2 }}>
            <Typography fontWeight="bold">注意事項</Typography>
            <Typography>
              {props?.eventInfo?.notes?.split('\n').map((line: string, index: number) => (
                <span key={index}>{line}<br /></span>
                ))}
            </Typography>
          </ListItem>
        </List>
      ) : (
        // PCサイズではテーブル形式で表示
        <Table>
          <TableBody>
            {/* イベント名 */}
            <TableRow>
              <TableCell sx={{ fontWeight: "bold", width: "25%", textAlign: "center" }}>イベント名</TableCell>
              <TableCell sx={{ textAlign: "left" }}>{props?.eventInfo?.eventName}</TableCell>
            </TableRow>

            {/* 日程 */}
            <TableRow>
              <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>日程</TableCell>
              <TableCell sx={{ textAlign: "left" }}>{props?.eventInfo?.eventDate}</TableCell>
            </TableRow>

            {/* バスケ時間 */}
            {props?.eventInfo?.b_eventTime ? (
              <>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>バスケ</TableCell>
                  <TableCell sx={{ textAlign: "left" }}>
                    {props?.eventInfo?.b_eventTime[0]} ～ {props?.eventInfo?.b_eventTime[1]}
                  </TableCell>
                </TableRow>
              </>) : (<></>)}

            {/* 飲み会時間 */}
            {props?.eventInfo?.d_eventTime ? (
              <>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>飲み会</TableCell>
                <TableCell sx={{ textAlign: "left" }}>
                  {props?.eventInfo?.d_eventTime[0]} ～ {props?.eventInfo?.d_eventTime[1]}
                </TableCell>
              </TableRow>
              </>
            ) : (<></>)}

            {/* 参加費 */}
            <TableRow>
              <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>参加費</TableCell>
              {props?.eventInfo?.d_entryFee > 0 && props?.eventInfo?.b_entryFee > 0 ? (
                <>
                  {/* バスケ、飲み会両方 */}
                  <TableCell sx={{ textAlign: "left" }}>
                    バスケ {props?.eventInfo?.b_entryFee}円 / 飲み会 {props?.eventInfo?.d_entryFee}円
                  </TableCell>
                </>
              ) : (
                <>
                  {props?.eventInfo?.b_entryFee > 0 ? (
                    <>
                      {/* バスケのみ */}
                      <TableCell sx={{ textAlign: "left" }}>{props?.eventInfo?.b_entryFee}円</TableCell>
                    </>
                  ) : (
                    <>
                      {props?.eventInfo?.d_entryFee > 0 ? (
                        <>
                          {/* 飲み会のみ */}
                          <TableCell sx={{ textAlign: "left" }}>{props?.eventInfo?.d_entryFee}円</TableCell>
                        </>
                      ) : (
                        <>
                          {/* どちらもない場合は何も表示しない */}
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </TableRow>

            {/* 開催場所 */}
            {props?.eventInfo?.arenaName ? (
              <>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>開催場所</TableCell>
                  <TableCell sx={{ textAlign: "left" }}>
                    {props?.eventInfo?.arenaUrl ? (
                      <Link href={props?.eventInfo?.arenaUrl} target="_blank" rel="noopener">
                        {props?.eventInfo?.arenaName}
                      </Link>
                    ) : props?.eventInfo?.arenaName}
                  </TableCell>
                </TableRow>
              </>
            ) : (<></>)}

            {/* 飲み会場 */}
            {props?.eventInfo?.restaurant ? (
              <>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>飲み会場</TableCell>
                  <TableCell sx={{ textAlign: "left" }}>
                    {props?.eventInfo?.restaurantUrl ? (
                      <Link href={props?.eventInfo?.restaurantUrl} target="_blank" rel="noopener">
                        {props?.eventInfo?.restaurant}
                      </Link>
                    ) : props?.eventInfo?.restaurant}
                  </TableCell>
                </TableRow>
              </>
            ) : (<></>)}

            {/* 集合 */}
            <TableRow>
              <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>集合</TableCell>
              <TableCell sx={{ textAlign: "left" }}>{props?.eventInfo?.meeting[0]} {props?.eventInfo?.meeting[1]}</TableCell>
            </TableRow>

            {/* 人数 */}
            <TableRow>
              <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>人数</TableCell>
              <TableCell sx={{ textAlign: "left" }}>
                {props?.eventInfo?.participantsNum}人 / {props?.eventInfo?.capacityNum}人
                {/* 男性満員の場合、その旨を表示 */}
                {props?.eventInfo?.manParticipantsNum >= props?.eventInfo?.manCapacityNum ? (<><Typography>※男性満員です</Typography></>) : (<></>)}
                {/* 女性満員の場合、その旨を表示 */}
                {props?.eventInfo?.womanParticipantsNum >= props?.eventInfo?.womanCapacityNum ? (<><Typography>※女性満員です</Typography></>) : (<></>)}  
                {/* 満員の場合、キャンセル待ちを表示 */}
                {props?.eventInfo?.isSoldOut ? (
                  <>
                    <Typography>現在のキャンセル待ち：{props?.eventInfo?.cancelWaitReserveNum}人</Typography>
                  </>
                ) : (<></>)}
                {/* 満員の場合、キャンセル待ち位置を表示 */}
                {props?.eventInfo?.isSoldOut && props?.eventInfo?.cancelWaitPotision > 0 ? (
                  <>
                    {/* 改修完了まで表示を消す */}
                    {/* <Typography fontWeight={"bold"} color={"error.main"}>あなたはキャンセル待ち{props?.eventInfo?.cancelWaitPotision}番手です</Typography> */}
                  </>
                ) : (<></>)}
              </TableCell>
            </TableRow>

            {/* 内容 */}
            <TableRow>
              <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>内容</TableCell>
              <TableCell sx={{ textAlign: "left" }}>
                {props?.eventInfo?.eventContent?.split('\n').map((line: string, index: number) => (
                  <span key={index}>{line}<br /></span>
                 ))}
              </TableCell>
            </TableRow>

            {/* 持ち物 */}
            <TableRow>
              <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>持ち物</TableCell>
              <TableCell sx={{ textAlign: "left" }}>
                {props?.eventInfo?.belongings?.split('\n').map((line: string, index: number) => (
                  <span key={index}>{line}<br /></span>
                 ))}
              </TableCell>
            </TableRow>

            {/* 設備 */}
            <TableRow>
              <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>設備</TableCell>
              <TableCell sx={{ textAlign: "left" }}>
                {props?.eventInfo?.facility?.split('\n').map((line: string, index: number) => (
                  <span key={index}>{line}<br /></span>
                 ))}
              </TableCell>
            </TableRow>

            {/* 注意事項 */}
            <TableRow>
              <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>注意事項</TableCell>
              <TableCell sx={{ textAlign: "left" }}>
                {props?.eventInfo?.notes?.split('\n').map((line: string, index: number) => (
                  <span key={index}>{line}<br /></span>
                 ))}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
    )}
    </TableContainer>
  );
};
